import { render, staticRenderFns } from "./jubao.vue?vue&type=template&id=3bb80d5a&scoped=true"
import script from "./jubao.vue?vue&type=script&lang=js"
export * from "./jubao.vue?vue&type=script&lang=js"
import style0 from "./jubao.vue?vue&type=style&index=0&id=3bb80d5a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb80d5a",
  null
  
)

export default component.exports